import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityDataAccessSearchUserSlice } from './get';

export const coreDataSecurityDataAccessSearchUserReducers = combineReducers({
	get: getCoreDataSecurityDataAccessSearchUserSlice.asyncReducers
});

export const coreDataSecurityDataAccessSearchUserWatchers = combineAllWatchers([
	getCoreDataSecurityDataAccessSearchUserSlice.asyncWatchers
]);
